<template>
  <div>
    <v-snackbar
      v-model="$store.state.snackbar.isSnackBarShown"
      :multi-line="true"
      :timeout="-1">
      <p class="medium-p white--text font-weight-medium mr-auto">
        {{ $store.state.snackbar.title }}
      </p>
      <v-row
        v-if="$store.state.snackbar.pdfLink"
        no-gutters>
        <p class="mr-2">
          <a>
            PREVIEW
          </a>
        </p>
        <p>
          <a>
            DOWNLOAD
          </a>
        </p>
      </v-row>
      <p class="small-p white--text pr-4">
        {{ $store.state.snackbar.text }}
      </p>
      <v-icon
        color="#fff"
        style="position: absolute; right: 8px; top: 8px"
        @click="closeSnackBar">
        mdi-close
      </v-icon>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: 'SnackBar',
  data: () => ({
    items: [],
  }),
  methods: {
    closeSnackBar() {
      this.$store.state.snackbar.isSnackBarShown = false;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .v-snack__wrapper {
  max-width: 320px;
  .v-snack__content {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 16px;
    p {
      margin-bottom: 0;
    }
  }
}
</style>
